// removed by extract-text-webpack-plugin
module.exports = {"digitalnsw-content":"digitalnsw-content_35F","h1":"h1_3i_","h2":"h2_2gK","h3":"h3_27i","h4":"h4_1Ne","h5":"h5_2zM","digitalHeader":"digitalHeader_2gU","withButtons":"withButtons_54-","headerRow":"headerRow_1Wp","headerColumnLeft":"headerColumnLeft_3iA","headerColumnRight":"headerColumnRight_ttA","headerHeading":"headerHeading_3j6","headerLink":"headerLink_20K","headerLinkDescription":"headerLinkDescription_3nE","headerButtonRow":"headerButtonRow_3ZD","headerButton":"headerButton_3rP","headerButtonRowActive":"headerButtonRowActive_1w8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/digital-header/digital-header.scss
// module id = 646
// module chunks = 0 1